<template>
  <div class="chat-message-list scrollbar-width-none" ref="messageListRef" @click="onMessageClick($event)">
    <div v-if="!messageList.length" class="onboarding-info">
      <ChatSuggest showTitle :onboardingInfo="onboardingInfo" @send="onSend" />
    </div>
    <template v-if="messageList.length">
      <div
        class="chat-item"
        ref="messageElementListRef"
        v-for="(message, messageIndex) in messageList"
        :key="message.id"
        :class="{'chat-item-bot': botId === message.bot_id}"
        :id="message.id"
        :chat-id="message.chat_id"
      >
        <div class="chat-item-row">
          <!-- <div class="chat-avatar" v-if="botId === message.bot_id">
            <van-image width="30" height="30" :src="botId === message.bot_id ? botImage : userImage" />
          </div> -->

          <div
            class="chat-content"
            :class="{'chat-content-block': cardTypeList.includes(message.content_type)}"
          >
            <template v-if="message.content_type === 'text'">
              <div class="chat-content-msg">
                <template v-if="message.role === 'user'">
                  <span class="msg-text">{{message.content}}</span>
                </template>
  
                <template v-if="message.role === 'assistant' && message.type === 'answer'">
                  <Markdown :message="message" />
                </template>
              </div>
            </template>

            <template v-if="message.content_type === 'card'">
              <div class="chat-card-content">
                <!-- <div v-if="message.loading" class="msg-card-loading">
                  <div class="mag-card-loading-content">
                    <div class="loading-icon">
                      <van-icon v-if="message.loading" class="icon" name="replay" size="14px" />
                      <van-icon v-else class="icon" name="passed" size="14px" />
                    </div>
                    <div class="loading-text">请稍候...</div>
                  </div>
                </div> -->

                <template>
                  <MessageCard :message="message" />
                </template>
              </div>
            </template>

  
            <!-- 阴影处理 -->
            <div class="chat-follow-up-content" v-if="showFollowUp(message, messageIndex)">
              <div class="chat-follow-up-list" v-for="followup in followUpList" :key="followup.id">
                <span class="chat-follow-up-item" @click="onSend(followup)">{{followup}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import ChatSuggest from './ChatSuggest'
  import MessageCard from './message-card/MessageCard'
  import { throttle } from '@/utils'
  import Markdown from './message-card/Markdown'
  import { mapGetters } from 'vuex'
  import domainConfig from '@/config/domain'

  export default {
    components: {
      MessageCard,
      ChatSuggest,
      Markdown,
    },
    props: {
      botId: {
        type: String,
        default: ""
      },
      messageList: {
        type: Array,
        default: () => []
      },
      onboardingInfo: {
        type: Object,
        default: () => ({
          prologue: "",
          suggested_questions: []
        })
      },
      followUpList: {
        type: Array,
        default: () => []
      }
    },
    data() {
      const time = Date.now()
      return {
        distanceY: 20, // 距顶部距离
        cardTypeList: ['card', 'custom_card'], // 卡片类型
        botImage: "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/tangjiu/onboarding_title_bot.png?_t=" + time,
        userImage: "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/tangjiu/chat_user_avatar.png?_t=" + time
      }
    },
    computed: {
      ...mapGetters(['miniEnv'])
    },
    mounted() {
      // this.$refs.messageListRef.addEventListener('scroll', this.handelScrollListScroll)
    },
    methods: {
      showFollowUp(message, index) {
        return message.bot_id === this.botId && this.messageList.length === index + 1 && this.followUpList.length
      },
      loadMoreMessages() {
        const container = this.$refs.messageListRef

        if (container.scrollTop <= this.distanceY) {
          this.$emit('loadMore', true)
        }
      },
      handelScrollListScroll: throttle(function() {
        this.loadMoreMessages()
      }, 150, {
        leading: false,
      }),
      scrollToPosition(config = {}) {
        return new Promise((resolve, reject) => {
          requestAnimationFrame(() => {
            if (!this.$refs.messageListRef) {
              reject()
            }
            const container = this.$refs.messageListRef
            // 底部
            if (config.scrollToBottom) {
              container.scrollTop = container.scrollHeight
            } else if (config.scrollToMessage) {
              // 某个元素
              const targetMessageDom = this.$refs.messageElementListRef.find(dom => dom.id === config.scrollToMessage.id)
              if (targetMessageDom.scrollIntoView) {
                targetMessageDom.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
              }
            } else if (config.scrollToOffset) {
              if (config.scrollToOffset.top) {
                container.scrollTop = config.scrollToOffset.top
              } else if (config.scrollToOffset.bottom) {
                container.scrollTop = container.scrollHeight - config.scrollToOffset.bottom
              }
            }
            resolve()
          })
        })
      },
      onSend(text) {
        this.$emit('send', text)
      },
      onMessageClick(event) {
        const target = event.target
        // console.log(target.tagName, 'tagName')

        if (target.tagName === 'A') {
          if (!this.miniEnv) {
            const url = event.target.href
            if (url) {
              event.preventDefault()
              window.open(url)
            }
            return
          }

          // 小程序 复制链接
          // const url = event.target.href
          // const hostList = domainConfig['242873']
          // const passed = hostList.some(item => url.includes(item))

          // if (!passed) {
          //   event.preventDefault()
          //   event.stopPropagation()
          //   this.handleCopy(url)
          //   this.$Toast('复制成功')
          // }
        } else if (target.tagName === 'IMG') {
          const url = event.target.src
          this.$ImagePreview({
            images: [url],
            closeable: true,
            showIndex: false
          })
        }
      },
      handleCopy(value) {
        const input = document.createElement("input")
        input.setAttribute("readonly", "readonly")
        input.setAttribute("value", value)
        document.body.appendChild(input)
        input.setSelectionRange(0, 9999)
        input.select()
        document.execCommand("copy")
        document.body.removeChild(input)
      }
    },
    unmounted() {
      // this.$refs.messageListRef.removeEventListener('scroll', this.handelScrollListScroll)
    }
  }
</script>

<style lang="scss" scoped>
.chat-message-list {
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}
.chat-item {
  display: flex;
  flex-direction: row-reverse;
  margin-bottom: 18px;
  box-sizing: border-box;
  &:last-child{
    margin-bottom: 4px;
  }
  &.chat-item-bot {
    flex-direction: row;
    .chat-item-row {
      flex-direction: row;
      .chat-content {
        /* margin-left: 8px; */
        padding-right: 0;
        &.chat-content-block {
          min-width: 0;
          width: 100%;
          .chat-content-msg {
            padding: 0;
            background: #FBFBFB;
            box-shadow: 0px 2px 4px 0px rgba(7,41,177,0.05);
          }
          .chat-card-content {
            .msg-card-loading {
              width: 200px;
              padding: 12px 8px;
              box-sizing: border-box;
              border-radius: 10px 10px 10px 10px;
              background: #ffffff;
              .mag-card-loading-content {
                width: 100%;
                display: flex;
                align-items: center;
              }
              .loading-icon {
                width: 14px;
                height: 14px;
                position: relative;
                .icon {
                  width: 100%;
                  height: 100%;
                  position: absolute;
                  left: 0;
                  top: 0;
                }
              }
              .loading-text {
                font-size: 12px;
                color: rgba(0, 0, 0, 0.65);
              }
            }
          }
        }
        .chat-content-msg {
          padding: 12px 12px;
          box-shadow: 0px 2px 4px 0px rgba(7,41,177,0.05);
          border-radius: 10px 10px 10px 0px;
          background: #FBFBFB;
        }
        .chat-follow-up-content {
          padding: 14px 0 8px;
          .chat-follow-up-list {
            margin-bottom: 8px;
            &:last-child {
              margin-bottom: 0;
            }
          }
          .chat-follow-up-item {
            display: inline-block;
            padding: 8px 12px;
            box-sizing: border-box;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid rgba(0,0,0,0.1);
            font-weight: 400;
            font-size: 14px;
            color: rgba(0,0,0,0.65);
          }
        }
      }
    }
    
  }

  .chat-item-row {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    .chat-avatar {
      width: 30px;
      height: 30px;
    }
    .chat-content {
      .chat-content-msg {
        padding: 8px 12px;
        box-sizing: border-box;
        background: linear-gradient( 270deg, #737EFF 0%, #9F8DFC 100%);
        box-shadow: 0px 4px 8px 0px rgba(7,41,177,0.05);
        border-radius: 10px 10px 0px 10px;
        .msg-text {
          color: #ffffff;
          font-size: 15px;
          word-break: break-all;
          white-space: pre-wrap;
        }
      }
    }
  }
}
</style>
